<template>
  <v-dialog v-model="visible" max-width="500px">
    <v-card>
      <v-card-title class="headline">プロパティ選択とソート</v-card-title>

      <v-card-text>
        <!-- プロパティ選択 -->
        <v-select v-model="selectedProperty" :items="filteredProperties" item-title="propertyName" item-value="propertyId"
          label="ソート対象のプロパティを選んでください" />

        <!-- ソート方法の選択 -->
        <v-select v-model="selectedSort" :items="sortOptions" item-title="label" item-value="value"
          label="ソート方法を選んでください" class="mt-4" />
      </v-card-text>

      <v-card-actions>
        <v-btn color="green" @click="applySelection">適用</v-btn>
        <v-btn @click="closeDialog">閉じる</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      authUserId: localStorage.getItem("authUserId"),
      sessionKey: localStorage.getItem("sessionKey"),
      propertyId: null,
      propertName: null,
      selectedProperty: "", // 選択されたプロパティ
      selectedSort: "", // 選択されたソート方法
      propertyOptions: [], // ユニークプロパティリスト
      sortProperties: [],
      properties: [],
      sortOptions: [
        { label: "昇順", value: "ASC" },
        { label: "降順", value: "DESC" },
      ], // ソートリスト
    };
  },
  computed: {
    visible: {
      get() {
        return this.modelValue;
      },
      set(val) {
        this.$emit("update:modelValue", val);
      },
      
    },
    filteredProperties() {
    const allowedTypes = ['1', '2', '3', '4', '5', '7'];
    return this.properties.filter(p => allowedTypes.includes(p.propertyType));
   }
  },
  watch: {
    visible(newVal) {
      if (!newVal) {
        this.selectedProperty = "";
        this.selectedSort = "";
      }
    },
    filteredProperties(newList) {
    const exists = newList.some(item => item.propertyId === this.selectedProperty);
    if (!exists) {
      this.selectedProperty = "";
      this.selectedSort = "";
    }
    },
    data: {
      immediate: true,
      handler(newData) {
        if (!newData || !newData.data || !Array.isArray(newData.data) || newData.data.length === 0) {
          // console.error("無効なデータ構造です。'data'が見つかりません:", newData);
          this.propertyOptions = [];
          this.propertyName = [];
          this.propertyId = [];
          this.properties = [];
          return;
        }
        this.propertyOptions = this.getUniqueProperties(newData);
        console.log("ソート対象プロパティたち:", this.propertyOptions);
        this.propertyName = this.propertyOptions.map(
          (item) => item.property.propertyName
        );
        this.propertyId = this.propertyOptions.map(
          (item) => item.property.propertyId
        );
        this.properties = this.propertyOptions.map((item) => ({
          propertyId: item.property.propertyId,
          propertyType: item.property.propertyType,
          propertyName: item.property.propertyName,
        }));
        console.log("ソート用のプロパティたちは、", this.sortOptions);
      },
    },
  },
  methods: {
    // ユニークなプロパティを抽出する
    getUniqueProperties(data) {
      if (!Array.isArray(data.data)) {
        console.error("渡されたデータが配列ではありません:", data.data);
        return [];
      }

      const seen = new Set();
      return data.data[0].properties.filter((item) => {
        const isUnique = !seen.has(item.property.propertyName);
        seen.add(item.property.propertyName); // プロパティ名でユニーク判定
        console.log("getUniqueProperties result", isUnique);
        return isUnique;
      });
    },

    // 選択を適用
    applySelection() {
      // 選択されたプロパティを検索
      const selectedProperty = this.properties.find(
        (property) => property.propertyId === this.selectedProperty
      );

      // もし該当するプロパティが見つからない場合はエラーを出力
      if (!selectedProperty) {
        alert("選択されたプロパティが無効です");
        return;
      }
      if (!this.selectedSort){
        alert("ソート方法を選んでください");
        return;
      }

      // JSON形式で返却するオブジェクト
      const result = {
        propertyId: this.selectedProperty || null,
        propertyType: selectedProperty.propertyType || null,
        sortOrder: this.selectedSort || null,
      };

      // 親コンポーネントに結果を送信
      this.$emit("applySelection", result);

      // ダイアログを閉じる
      this.closeDialog();
    },


    // ダイアログを閉じる
    closeDialog() {
      this.visible = false;
    },
  },
};
</script>
